import * as Joi from 'joi'

import { DirectDebitForm } from '../types'

export const validateNumber: Joi.CustomValidator<string> = (value, helper) => {
  if (!String(value).length) return helper.error('any.required')

  return value
}

export const directDebitSchema = Joi.object<DirectDebitForm>({
  bank: {
    number: Joi.string()
      .valid('001', '041', '104', '341', '237', '033')
      .required(),
    name: Joi.string().required(),
    icon: Joi.string().optional().allow('', null),
  },
  agency: {
    number: Joi.required().custom(validateNumber).messages({
      'any.required': 'Agência inválida',
    }),
    digit: Joi.required().custom(validateNumber).messages({
      'any.required': 'Dígito inválido',
    }),
  },
  account: {
    number: Joi.required().custom(validateNumber).messages({
      'any.required': 'Conta inválida',
    }),
    digit: Joi.number().optional().allow('', null),
  },
  paymentMethodType: Joi.string().valid('DIRECT_DEBIT').required(),
  accountId: Joi.string().uuid().required(),
})
